import axios from "../../axios";
import React, { useState, useEffect } from "react";
import { BiLock, BiLogoMicrosoftTeams } from "react-icons/bi";
import { connect } from "react-redux";
import { BsShare } from "react-icons/bs";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import {
  Alert,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledDropdown,
} from "reactstrap";
import { SlLayers } from "react-icons/sl";
import { getSlackChannels, getTeamsChannels } from "../../utils/url";
import { data } from "jquery";
import { serverAuthBaseUrl, Spinner } from "../../utils/constants";
import { toastContainer } from "../../utils/toast";
import * as actionCreators from "../../modules/actions";
import InitialLinkButton from "./InitialLinkButton";
import { AiFillCloseCircle } from "react-icons/ai";

function TeamsSharePopup({
  handleSocialShare,
  teamsShared = [],
  answer,
  orgId,
  userId,
  setShowTeamsPopup,
  organization,
  setReturnUrlAfterSlackTeamsAuth,
}) {
  const [teamsChannels, setTeamsChannels] = useState([]);
  const [channelsLoading, setChannelsLoading] = useState(false);
  const [sharedId, setSharedId] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    setChannelsLoading(true);
    axios
      .get(getTeamsChannels)
      .then(({ data }) => {
        console.log(data.data);
        setTeamsChannels([...data.data]);
        setChannelsLoading(false);
      })
      .catch((err) => {
        setChannelsLoading(false);
        console.log(err.response.data.errors.message);
        // if (err.response && err.response.data.errors) {
        //   toastContainer(err.response.data.errors.message, "error");
        // }
      });
  }, []);

  const client_id = "c75b122a-b88e-404e-99c6-b2430bde81ad";

  // const client_id = "c75b122a-b88e-404e-99c6-b2430bde81ad"

  const getTenantNameById = (id) => {
    const tenant = organization.allowedTeamsTenants
      ? organization.allowedTeamsTenants.find((x) => x.workspaceId == id)
      : null;

    if (tenant) {
      return tenant.workspaceName;
    } else {
      return "No name";
    }
  };

  return (
    <Modal
      isOpen={true}
      className="dashboardModalContainer dashboardModalDetailsContainer"
    >
      <ModalHeader
        toggle={() => setShowTeamsPopup(false)}
        className="slack_team_share_header"
        close={<AiFillCloseCircle color="white" size={25} onClick={() => setShowTeamsPopup(false)} />}
      >
        <div className="dashboardModalTitle">Select Teams Channels</div>
      </ModalHeader>

      <ModalBody className={"dani-channel-modal"}>
        {channelsLoading ? (
          <img src={Spinner} className="spinner-pos" />
        ) : (
          <div>
            {organization &&
            organization.allowedTeamsTenants &&
            organization.allowedTeamsTenants.length > 0 ? (
              <div>
                {organization.allowedTeamsTenants.length == 1 ? (
                  <div>
                    {teamsChannels.length === 0 ? (
                      <InitialLinkButton
                        iconComp={
                          <BiLogoMicrosoftTeams color="white" size={22} />
                        }
                        type="TEAMS"
                        text={"Connect Teams"}
                        onClick={() => {
                          setReturnUrlAfterSlackTeamsAuth(
                            window.location.pathname
                          );
                          window.open(`https://login.microsoftonline.com/${
                            organization.allowedTeamsTenants[0].workspaceId
                          }/oauth2/v2.0/authorize?
                    client_id=${client_id}
                    &response_type=code
                     &redirect_uri=${encodeURIComponent(
                       serverAuthBaseUrl() + "public/teams-auth"
                     )}
                    &response_mode=query
                     &scope=${encodeURIComponent(
                       "offline_access Channel.ReadBasic.All ChannelMessage.Send User.Read.All"
                     )}  
                    &state=${userId}_${orgId}_${
                            organization.allowedTeamsTenants[0].workspaceId
                          }`);
                        }}
                      />
                    ) : (
                      <Button
                        className="float-right"
                        onClick={() => {
                          setReturnUrlAfterSlackTeamsAuth(
                            window.location.pathname
                          );
                          window.open(`https://login.microsoftonline.com/${
                            organization.allowedTeamsTenants[0].workspaceId
                          }/oauth2/v2.0/authorize?
                    client_id=${client_id}
                    &response_type=code
                     &redirect_uri=${encodeURIComponent(
                       serverAuthBaseUrl() + "public/teams-auth"
                     )}
                    &response_mode=query
                     &scope=${encodeURIComponent(
                       "offline_access Channel.ReadBasic.All ChannelMessage.Send User.Read.All"
                     )}  
                    &state=${userId}_${orgId}_${
                            organization.allowedTeamsTenants[0].workspaceId
                          }`);
                        }}
                      >
                        Connect Teams
                      </Button>
                    )}
                  </div>
                ) : (
                  <div>
                    <UncontrolledDropdown
                      direction="down"
                      className="text-right"
                    >
                      {teamsChannels.length === 0 ? (
                        <DropdownToggle
                          tag="div"
                          className="DropdownToggleTeamsLinkMulti"
                        >
                          <InitialLinkButton
                            onClick={() => {}}
                            iconComp={
                              <BiLogoMicrosoftTeams color="white" size={22} />
                            }
                            text={"Connect Teams"}
                          />
                        </DropdownToggle>
                      ) : (
                        <DropdownToggle>Connect to Teams</DropdownToggle>
                      )}

                      <DropdownMenu
                        className={
                          teamsChannels.length === 0
                            ? "team_link_drop_down"
                            : ""
                        }
                      >
                        {organization.allowedTeamsTenants.map((item) => {
                          const url = `https://login.microsoftonline.com/${
                            item.workspaceId
                          }/oauth2/v2.0/authorize?
                         client_id=${client_id}
                         &response_type=code
                          &redirect_uri=${encodeURIComponent(
                            serverAuthBaseUrl() + "public/teams-auth"
                          )}
                         &response_mode=query
                          &scope=${encodeURIComponent(
                            "offline_access Channel.ReadBasic.All ChannelMessage.Send User.Read.All"
                          )}  
                         &state=${userId}_${orgId}_${item.workspaceId}`;
                          return (
                            <DropdownItem
                              onClick={() => {
                                setReturnUrlAfterSlackTeamsAuth(
                                  window.location.pathname
                                );

                                window.open(url);
                              }}
                            >
                              {item.workspaceName}
                            </DropdownItem>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="">
              {channelsLoading ? (
                <img src={Spinner} className="spinner-pos" />
              ) : teamsChannels.length > 0 ? (
                <div>
                  <Alert
                    isOpen={error}
                    toggle={() => setError(null)}
                    color="danger"
                  >
                    {error}
                  </Alert>
                  {teamsChannels.map((tenant) => {
                    if (!tenant.tenantId) {
                      return "";
                    } else {
                      return (
                        <div>
                          <h5 className="text-success font-weight-bold">
                            Tenant : {getTenantNameById(tenant.tenantId)}
                          </h5>
                          {tenant.teams &&
                            tenant.teams.map((wp) => {
                              return (
                                <div className="my-2 ml-3">
                                  <h5>Workspace : {wp.teamName}</h5>
                                  <div className="fixTableHead">
                                    <table>
                                      <thead>
                                        <tr>
                                          <th style={{ width: "40%" }}>
                                            Channel Name
                                          </th>
                                          {/* <th style={{ width: "10%" }}>Members</th> */}
                                          <th style={{ width: "40%" }}>
                                            Share
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {wp.channels.length === 0 && (
                                          <span>No channels added</span>
                                        )}
                                        {wp.channels.map((item, index) => {
                                          const isShared = teamsShared.length
                                            ? teamsShared.includes(item.id)
                                            : sharedId.find(
                                                (x) => x.id === item.id
                                              );

                                          return (
                                            <tr
                                              className={`dani-slack-channel-row${index}`}
                                            >
                                              <td style={{ width: "40%" }}>
                                                {item.displayName}
                                              </td>
                                              {/* <td style={{ width: "10%" }}>-</td> */}
                                              <td
                                                style={{ width: "40%" }}
                                                className="dani-slack-popup-shareBtn"
                                              >
                                                {" "}
                                                {isShared ? (
                                                  <span
                                                    className={
                                                      isShared.anonymousShared
                                                        ? "shared_succ_chipp_anonymous"
                                                        : "shared_succ_chipp"
                                                    }
                                                  >
                                                    Shared Successfully!
                                                  </span>
                                                ) : (
                                                  <span>
                                                    <Button
                                                      color="info"
                                                      onClick={() => {
                                                        handleSocialShare({
                                                          type: "TEAMS",
                                                          channelId: item.id,
                                                          teamName:
                                                            item.displayName,
                                                          teamId: wp.teamId,
                                                          answer,
                                                          tenantId:
                                                            tenant.tenantId,
                                                        })
                                                          .then((data) => {
                                                            setSharedId([
                                                              ...sharedId,
                                                              {
                                                                id: data,
                                                                anonymousShared: false,
                                                              },
                                                            ]);
                                                          })
                                                          .catch((err) => {
                                                            setError(err);
                                                          });
                                                      }}
                                                    >
                                                      Share <BsShare />{" "}
                                                    </Button>

                                                    <Button
                                                      // color="info"
                                                      className="dani-slack-chat-anonymous"
                                                      onClick={() => {
                                                        handleSocialShare({
                                                          type: "TEAMS",
                                                          channelId: item.id,
                                                          teamName:
                                                            item.displayName,
                                                          teamId: wp.teamId,
                                                          isAnonymous: true,
                                                          answer,
                                                          tenantId:
                                                            tenant.tenantId,
                                                        })
                                                          .then((data) => {
                                                            setSharedId([
                                                              ...sharedId,
                                                              {
                                                                id: data,
                                                                anonymousShared: true,
                                                              },
                                                            ]);
                                                          })
                                                          .catch((err) => {
                                                            setError(err);
                                                          });
                                                      }}
                                                    >
                                                      Share anonymously
                                                      <BsShare />{" "}
                                                    </Button>
                                                  </span>
                                                )}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      );
                    }
                  })}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setReturnUrlAfterSlackTeamsAuth: (data) =>
      dispatch(actionCreators.setReturnUrlAfterSlackTeamsAuth(data)),
  };
};

export default connect(null, mapDispatchToProps)(TeamsSharePopup);
